import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quality-assurance-testing',
  templateUrl: './quality-assurance-testing.component.html',
  styleUrls: ['./quality-assurance-testing.component.css']
})
export class QualityAssuranceTestingComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/quality-assurance-testing/quality-assurance-testing.component.ts